import { Grid } from "@material-ui/core";
import { Controller, useFormContext } from "react-hook-form";
import { FileField } from "../../../components/forms/file-3";
import { useImagePreview } from "../../../components/image/image-preview";
import { VerificationDTO } from "../../../store/verification/models/dto/due-diligence";
import { BackgroundColour } from "./background-color";
import { PreviewHeader } from "./preview";

type RequestType = VerificationDTO.Requests.DueDiligence.Config.Post.T;

export function Header() {
  const { watch, control } = useFormContext<RequestType>();

  const imagePreview = useImagePreview(watch("header.image"));

  const css = watch("header.css");

  return (
    <>
      <Grid item xs={12} md={6}>
        <Controller
          control={control}
          name="header.image"
          render={({ field, fieldState: { error } }) => (
            <FileField
              {...field}
              error={!!error}
              helperText={error?.message}
              label="Image"
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={3}>
          <BackgroundColour />
        </Grid>
      </Grid>
      <PreviewHeader imageData={imagePreview} cssValue={css || {}} />
    </>
  );
}
